export enum LegalSettingTypes {
  IsLegalGuaranteeOfConformity = 'isLegalGuaranteeOfConformity',
  IsMemberOfAccreditedAssociation = 'isMemberOfAccreditedAssociation',
  IsVatOnDebitsEnabled = 'isVatOnDebitsEnabled',
}
